/**
 * SubPageTextAnim — 서브페이지 공통 텍스트(블록) 등장 애니메이션
 * data-sub-text-anim 이 있으면 뷰포트 진입 시 아래→위 등장 (GSAP + ScrollTrigger, AOS 미사용)
 */
const ATTR = "data-sub-text-anim";

export function initSubPageTextAnim() {
    if (typeof gsap === "undefined") return;

    const elements = document.querySelectorAll(`[${ATTR}]`);
    if (elements.length === 0) return;

    if (typeof ScrollTrigger !== "undefined" && gsap.registerPlugin) {
        gsap.registerPlugin(ScrollTrigger);
    }

    elements.forEach((el) => {
        gsap.fromTo(
            el,
            { opacity: 0, y: 28 },
            {
                opacity: 1,
                y: 0,
                duration: 0.65,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 88%",
                    toggleActions: "play none none none",
                },
            }
        );
    });
}
